import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import ProductIndex from '../views/Product/Index.vue'
import ProductEdit from '../views/Product/Edit.vue'
import ProductSort from '../views/Product/Sort.vue'
import ProductReport from '../views/Product/Report.vue'
import TagIndex from '../views/Tags/Index.vue'
import ReservedBonusIndex from '../views/ReservedBonus/Index.vue'
import PayInvoiceIndex from '../views/PayInvoice/Index.vue'
import DayStatsIndex from '../views/PayInvoice/DayStats.vue'
import ModifierCategoryIndex from '../views/ModifierCategories/Index.vue'
import ModifierIndex from '../views/Modifier/Index.vue'
import ModifierEdit from '../views/Modifier/Edit.vue'
import CategoryIndex from '../views/Category/Index.vue'
import CategoryEdit from '../views/Category/Edit.vue'
import ModifiersGroupIndex from '../views/Modificator/Index.vue'
import ConstructorIndex from '../views/Constructor/Index.vue'
import SaleIndex from '../views/Sale/Index.vue'
import SaleEdit from '../views/Sale/Edit.vue'
import OrderIndex from '../views/Order/Index.vue'
import DeliveryIndex from '../views/Delivery/Index.vue'
import AreaEdit from '../views/Delivery/Area/Edit.vue'
import StreetEdit from '../views/Delivery/Street/Edit.vue'
import BranchEdit from '../views/Delivery/Branch/Edit.vue'
import WorkshopEdit from '../views/Delivery/Workshop/Edit.vue'
import UserIndex from '../views/User/Index.vue'
import UserEdit from '../views/User/Edit.vue'
import PromocodeEdit from '../views/Promocode/Edit.vue'
import PromocodeHome from '../views/Promocode/Home.vue'
import PromocodeOrders from '../views/Promocode/Orders.vue'
import BannerEdit from '../views/Banner/Edit.vue'
import BannerIndex from '../views/Banner/Index.vue'
import ChangePriceEdit from '../views/ChangePrice/Edit.vue'
import ChangePriceIndex from '../views/ChangePrice/Index.vue'
import NewsEdit from '../views/News/Edit.vue'
import NewsIndex from '../views/News/Index.vue'
import ArticleEdit from '../views/Articles/Edit.vue'
import ArticleIndex from '../views/Articles/Index.vue'
import JobEdit from '../views/Job/Edit.vue'
import JobIndex from '../views/Job/Index.vue'
import OnlinePayAccountEdit from '../views/OnlinePayAccount/Edit.vue'
import OnlinePayAccountIndex from '../views/OnlinePayAccount/Index.vue'
import ComboProductEdit from '../views/ComboProduct/Edit.vue'
import ComboProductIndex from '../views/ComboProduct/Index.vue'
import CutleryItemEdit from '../views/CutleryItem/Edit.vue'
import CutleryItemIndex from '../views/CutleryItem/Index.vue'
import ContactIndex from '../views/Contact/Index.vue'
import PartnershipIndex from '../views/Partnership/Index.vue'
import PaymentDeliveryIndex from '../views/PaymentDelivery/Index.vue'
import InfoIndex from '../views/Info/Index.vue'
import ReviewIndex from '../views/Review/Index.vue'
import HomeIndex from '../views/Home/Index.vue'
import Login from '../views/Login.vue'
import TagLandingIndex from '../views/TagLanding/Index'
import TagLandingEdit from '../views/TagLanding/Edit'
import SeoTagLandingEdit from '../views/SeoTagLanding/Edit'
import SettingIndex from '../views/Setting/Index'
import LandingPageEdit from '../views/LandingPage/Edit'
import LandingPageIndex from '../views/LandingPage/Index'
import OfferPageEdit from '../views/OfferPage/Edit'
import OfferPageIndex from '../views/OfferPage/Index'
import SmsLogIndex from '../views/SmsLog/Index'
import AppLogIndex from '../views/AppLog/Index'
import NotificationLogIndex from '../views/NotificationLog/Index'
import StopsIndex from '../views/Stop/Index'
import StopModsIndex from '../views/StopMods/Index'
import StopGlovoIndex from '../views/StopGlovo/Index'
import StopModsGlovoIndex from '../views/StopModsGlovo/Index'
import PushIndex from '../views/PushNotification/Index'
import PushBonusIndex from '../views/PushBonusNotification/Index'
import PushNewClientIndex from '../views/PushNewClientNotification/Index'
import SessionIndex from '../views/Session/Index.vue'
import RoleIndex from '../views/Role/Index.vue'
import CourierMap from '../views/Courier/Map.vue'
import CourierIndex from '../views/Courier/Index.vue'
import CollectionIndex from '../views/Collection/Index.vue'
import CollectionEdit from '../views/Collection/Edit.vue'
import BlockIndex from '../views/Block/Index.vue'
import BlockEdit from '../views/Block/Edit.vue'


Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/courier',
        name: 'courier-index',
        component: CourierIndex
    },
    {
        path: '/courier/map',
        name: 'courier-map',
        component: CourierMap
    },
    {
        path: '/sms-log',
        name: 'sms-log-index',
        component: SmsLogIndex
    },
    {
        path: '/app-log',
        name: 'app-log-index',
        component: AppLogIndex
    },
    {
        path: '/product',
        name: 'product-index',
        component: ProductIndex
    },
    {
        path: '/product/create',
        props: true,
        name: 'product-create',
        component: ProductEdit
    },
    {
        path: '/product/sort',
        props: true,
        name: 'product-sort',
        component: ProductSort
    },
    {
        path: '/product/report',
        props: true,
        name: 'product-report',
        component: ProductReport
    },
    {
        path: '/push',
        props: true,
        name: 'push-index',
        component: PushIndex
    },
    {
        path: '/push-new-client',
        props: true,
        name: 'push-new-client-index',
        component: PushNewClientIndex
    },
    {
        path: '/push-bonus',
        props: true,
        name: 'push-bonus-index',
        component: PushBonusIndex
    },
    {
        path: '/push-log',
        props: true,
        name: 'push-log',
        component: NotificationLogIndex
    },
    {
        path: '/checkbox-logins',
        name: 'checkbox-login-index',
        component: () => import('@/views/CheckboxLogin/Index.vue')
    },
    {
        path: '/checkbox-logins/create',
        name: 'checkbox-login-create',
        component: () => import('@/views/CheckboxLogin/Edit.vue')
    },
    {
        path: '/checkbox-logins/:id/edit',
        name: 'checkbox-login-edit',
        component: () => import('@/views/CheckboxLogin/Edit.vue'),
        props: true
    },
    {
        path: '/role',
        props: true,
        name: 'role',
        component: RoleIndex
    },
    {
        path: '/session',
        props: true,
        name: 'session',
        component: SessionIndex
    },
    {
        path: '/stops',
        props: true,
        name: 'stops',
        component: StopsIndex
    },
    {
        path: '/stop-mods',
        props: true,
        name: 'stop-mods',
        component: StopModsIndex
    },
    {
        path: '/stop-glovo',
        props: true,
        name: 'stop-glovo',
        component: StopGlovoIndex
    },
    {
        path: '/stop-mods-glovo',
        props: true,
        name: 'stop-mods-glovo',
        component: StopModsGlovoIndex
    },
    {
        path: '/setting',
        props: true,
        name: 'setting-index',
        component: SettingIndex
    },
    {
        path: '/product/:id',
        props: true,
        name: 'product-edit',
        component: ProductEdit
    },
    {
        path: '/home',
        name: 'home-index',
        component: HomeIndex
    },
    {
        path: '/tag-landings',
        name: 'tag-landing-index',
        component: TagLandingIndex
    },
    {
        path: '/tag-landings/:id',
        name: 'tag-landing-edit',
        props: true,
        component: TagLandingEdit
    },
    {
        path: '/seo-tag-landings/:id',
        name: 'seo-tag-landing-edit',
        props: true,
        component: SeoTagLandingEdit
    },
    {
        path: '/seo-landing-page/create',
        name: 'seo-tag-landing-create',
        props: true,
        component: SeoTagLandingEdit
    },
    {
        path: '/landing-page/create',
        name: 'landing-page-create',
        props: true,
        component: LandingPageEdit
    },
    {
        path: '/landing-page',
        name: 'landing-page-index',
        component: LandingPageIndex
    },
    {
        path: '/landing-page/:id',
        name: 'landing-page-edit',
        props: true,
        component: LandingPageEdit
    },
    {
        path: '/offer-page/create',
        name: 'offer-page-create',
        props: true,
        component: OfferPageEdit
    },
    {
        path: '/offer-page',
        name: 'offer-page-index',
        component: OfferPageIndex
    },
    {
        path: '/offer-page/:id',
        name: 'offer-page-edit',
        props: true,
        component: OfferPageEdit
    },
    {
        path: '/collection/create',
        name: 'collection-create',
        props: true,
        component: CollectionEdit
    },
    {
        path: '/collection',
        name: 'collection-index',
        component: CollectionIndex
    },
    {
        path: '/collection/:id',
        name: 'collection-edit',
        props: true,
        component: CollectionEdit
    },
    {
        path: '/block/create',
        name: 'block-create',
        props: true,
        component: BlockEdit
    },
    {
        path: '/block',
        name: 'block-index',
        component: BlockIndex
    },
    {
        path: '/block/:id',
        name: 'block-edit',
        props: true,
        component: BlockEdit
    },
    {
        path: '/tags',
        name: 'tag-index',
        component: TagIndex
    },
    {
        path: '/pay-invoices',
        name: 'pay-invoices',
        component: PayInvoiceIndex
    },
    {
        path: '/day-stats',
        name: 'day-stats',
        component: DayStatsIndex
    },
    {
        path: '/modifier-categories',
        name: 'modifier-category-index',
        component: ModifierCategoryIndex
    },
    {
        path: '/contact',
        name: 'contact-index',
        component: ContactIndex
    },
    {
        path: '/partnership',
        name: 'partnership-index',
        component: PartnershipIndex
    },
    {
        path: '/payment-delivery',
        name: 'payment-delivery-index',
        component: PaymentDeliveryIndex
    },
    {
        path: '/info',
        name: 'info-index',
        component: InfoIndex
    },
    {
        path: '/modifier',
        name: 'modifier-index',
        component: ModifierIndex
    },
    {
        path: '/modifier/create',
        props: true,
        name: 'modifier-create',
        component: ModifierEdit
    },
    {
        path: '/modifier/:id',
        props: true,
        name: 'modifier-edit',
        component: ModifierEdit
    },
    {
        path: '/category',
        name: 'category-index',
        component: CategoryIndex
    },
    {
        path: '/category/create',
        name: 'category-create',
        props: true,
        component: CategoryEdit
    },
    {
        path: '/category/:id/subcategory/create',
        name: 'subcategory-create',
        props: true,
        component: CategoryEdit
    },
    {
        path: '/category/:id/subcategory/:subId',
        name: 'subcategory-edit',
        props: true,
        component: CategoryEdit
    },
    {
        path: '/category/:id',
        name: 'category-edit',
        props: true,
        component: CategoryEdit
    },
    {
        path: '/modifiers-group',
        name: 'modifiers-group-index',
        component: ModifiersGroupIndex
    },
    {
        path: '/constructor',
        name: 'constructor-index',
        component: ConstructorIndex
    },
    {
        path: '/sale',
        name: 'sale-index',
        component: SaleIndex
    },
    {
        path: '/sale/create',
        name: 'sale-create',
        props: true,
        component: SaleEdit
    },
    {
        path: '/sale/:id',
        name: 'sale-edit',
        props: true,
        component: SaleEdit
    },
    {
        path: '/order',
        name: 'order-index',
        component: OrderIndex
    },
    {
        path: '/delivery',
        name: 'delivery-index',
        props: true,
        component: DeliveryIndex
    },
    {
        path: '/area/create',
        name: 'area-create',
        props: true,
        component: AreaEdit
    },
    {
        path: '/area/:id',
        name: 'area-edit',
        props: true,
        component: AreaEdit
    },
    {
        path: '/promocode',
        name: 'promocode-index',
        component: PromocodeHome
    },
    {
        path: '/promocode/create',
        name: 'promocode-create',
        props: true,
        component: PromocodeEdit
    },
    {
        path: '/promocode/orders/:id',
        name: 'promocode-orders',
        props: true,
        component: PromocodeOrders
    },
    {
        path: '/promocode/:id',
        name: 'promocode-edit',
        props: true,
        component: PromocodeEdit
    },
    {
        path: '/news',
        name: 'news-index',
        component: NewsIndex
    },
    {
        path: '/news/create',
        name: 'news-create',
        props: true,
        component: NewsEdit
    },
    {
        path: '/news/:id',
        name: 'news-edit',
        props: true,
        component: NewsEdit
    },
    {
        path: '/article',
        name: 'article-index',
        component: ArticleIndex
    },
    {
        path: '/article/create',
        name: 'article-create',
        props: true,
        component: ArticleEdit
    },
    {
        path: '/article/:id',
        name: 'article-edit',
        props: true,
        component: ArticleEdit
    },
    {
        path: '/job',
        name: 'job-index',
        component: JobIndex
    },
    {
        path: '/job/create',
        name: 'job-create',
        props: true,
        component: JobEdit
    },
    {
        path: '/job/:id',
        name: 'job-edit',
        props: true,
        component: JobEdit
    },
    {
        path: '/online-pay-account',
        name: 'online-pay-account-index',
        component: OnlinePayAccountIndex
    },
    {
        path: '/online-pay-account/create',
        name: 'online-pay-account-create',
        props: true,
        component: OnlinePayAccountEdit
    },
    {
        path: '/online-pay-account/:id',
        name: 'online-pay-account-edit',
        props: true,
        component: OnlinePayAccountEdit
    },
    {
        path: '/reserved-bonuses',
        name: 'reserved-bonus-index',
        component: ReservedBonusIndex
    },
    {
        path: '/cutlery-items',
        name: 'cutlery-item-index',
        component: CutleryItemIndex
    },
    {
        path: '/cutlery-items/create',
        name: 'cutlery-item-create',
        props: true,
        component: CutleryItemEdit
    },
    {
        path: '/cutlery-items/:id',
        name: 'cutlery-item-edit',
        props: true,
        component: CutleryItemEdit
    },
    {
        path: '/combo-products',
        name: 'combo-product-index',
        component: ComboProductIndex
    },
    {
        path: '/combo-products/create',
        name: 'combo-product-create',
        props: true,
        component: ComboProductEdit
    },
    {
        path: '/combo-products/:id',
        name: 'combo-product-edit',
        props: true,
        component: ComboProductEdit
    },
    {
        path: '/banner',
        name: 'banner-index',
        component: BannerIndex
    },
    {
        path: '/banner/create',
        name: 'banner-create',
        props: true,
        component: BannerEdit
    },
    {
        path: '/banner/:id',
        name: 'banner-edit',
        props: true,
        component: BannerEdit
    },
    {
        path: '/change-price',
        name: 'change-price-index',
        component: ChangePriceIndex
    },
    {
        path: '/change-price/create',
        name: 'change-price-create',
        props: true,
        component: ChangePriceEdit
    },
    {
        path: '/change-price/:id',
        name: 'change-price-edit',
        props: true,
        component: ChangePriceEdit
    },
    {
        path: '/review',
        name: 'review-index',
        component: ReviewIndex
    },
    {
        path: '/street/create',
        name: 'street-create',
        props: true,
        component: StreetEdit
    },
    {
        path: '/street/:id',
        name: 'street-edit',
        props: true,
        component: StreetEdit
    },
    {
        path: '/branch/create',
        name: 'branch-create',
        props: true,
        component: BranchEdit
    },
    {
        path: '/branch/:id',
        name: 'branch-edit',
        props: true,
        component: BranchEdit
    },
    {
        path: '/workshop/create',
        name: 'workshop-create',
        props: true,
        component: WorkshopEdit
    },
    {
        path: '/workshop/:id',
        name: 'workshop-edit',
        props: true,
        component: WorkshopEdit
    },
    {
        path: '/user',
        name: 'user-index',
        component: UserIndex
    },
    {
        path: '/user/:id',
        props: true,
        name: 'user-edit',
        component: UserEdit
    },
    // {
    //     path: '/modifier/:id',
    //     props: true,
    //     name: 'modifier-edit',
    //     component: ModifierEdit
    // },
]

const router = new VueRouter({
    hashbang: false,
    mode: 'history',
    routes
})

export default router
